import { useEffect, useRef } from 'react';
import { useChat } from '../../hooks/useChat';

export function ChatLauncher() {
  const { isOpen, hasBeenOpened, open, minimize } = useChat();
  const btnRef = useRef<HTMLButtonElement>(null);

  // Return focus to launcher when panel is minimized
  useEffect(() => {
    if (!isOpen && hasBeenOpened) {
      btnRef.current?.focus();
    }
  }, [isOpen, hasBeenOpened]);

  const toggle = () => (isOpen ? minimize() : open());

  return (
    <button
      ref={btnRef}
      onClick={toggle}
      aria-label={isOpen ? 'Close chat with Aria' : 'Open chat with Aria'}
      className={[
        'fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full',
        'bg-[#53978e] text-white shadow-lg',
        'transition-all duration-200 ease-out hover:bg-[#3f7a72] hover:scale-105 active:scale-95',
        // Entrance animation on first paint
        'opacity-0',
      ].join(' ')}
      style={{
        animation: 'aria-fade-in 0.35s ease-out 0.3s forwards',
      }}
      title="Chat with Aria"
    >
      {/* Icon: chat bubble when closed, chevron-down when open */}
      {isOpen ? (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      ) : (
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
          />
        </svg>
      )}

      {/* Notification dot — shown until the user opens for the first time */}
      {!hasBeenOpened && (
        <span className="absolute -top-0.5 -right-0.5 flex h-3.5 w-3.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-red-500 ring-2 ring-white" />
        </span>
      )}
    </button>
  );
}
